<template>
  <b-overlay :show="loading">
    <div class="roster-page">

      <div class="ibox-title dashboard_title company-form-box-title pl-0 mb-3">
            <h4 class="clearfix">
                <span class="float-left">Pending Mobility Attendance
                    <span class="title-sub-text">Review and manage employee pending mobility attendances.</span>
                </span>
                <span class="float-right"></span>
            </h4>
        </div>

      <b-card class="bg-wash border-0 box-shadow-none">
        <b-card-body class="p-0">
          <roster-attendance-mobility-request-list
            :key="'pending-' + componentKey"
            :status="0"
            @changeLoading="changeLoading"
            @refreshLists="refreshLists"
            :roster="roster"
          ></roster-attendance-mobility-request-list>

          <!-- <roster-attendance-mobility-request-list
            :key="'approved-' + componentKey"
            :status="1"
            @changeLoading="changeLoading"
            @refreshLists="refreshLists"
            :roster="roster"
          ></roster-attendance-mobility-request-list> -->

          <roster-attendance-mobility-request-list
            :key="'declined-' + componentKey"
            :status="2"
            @changeLoading="changeLoading"
            @refreshLists="refreshLists"
            :roster="roster"
          ></roster-attendance-mobility-request-list>
        </b-card-body>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
export default {
  props: ['roster'],
  data() {
    return {
      loading: false,
      componentKey: 0
    };
  },

  methods: {
    changeLoading(loading) {
        this.loading = loading;
    },

    refreshLists() {
        this.loading = false;
        this.componentKey += 1;
    }
  }
};
</script>
